import { render, staticRenderFns } from "./CategoryTradeStats.vue?vue&type=template&id=b8d96032&scoped=true"
import script from "./CategoryTradeStats.vue?vue&type=script&lang=js"
export * from "./CategoryTradeStats.vue?vue&type=script&lang=js"
import style0 from "./CategoryTradeStats.vue?vue&type=style&index=0&id=b8d96032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d96032",
  null
  
)

export default component.exports